<template>
	<v-container>
		<v-row >
			<v-col cols="4"  xs="12" sm="6" md="4"  class="pa-0" >
				<v-card class="elevation-0 transparent" >
				  <v-card-title class=" font-weight-black"> 
				  	LISTADO DE SERIES 
				  	<v-spacer></v-spacer>
				  </v-card-title>
				  <v-card-text>
				  	<!-- <v-btn color="primary" class="mb-1" @click="getSeries">Consultar todo</v-btn> -->
				    <v-select 
				    	class="mb-1"
              dense
              outlined
              :items="series"
              v-model="serie"
              item-text="nomserie"
              item-value="idserie" 
              label="Serie"
              return-object
              single-line
              hide-details
            ></v-select>
            <v-select 
              dense
              outlined
              :items="serie.categorias"
              v-model="seriecatego"
              item-text="nomcatego"
              item-value="idcategoria" 
              label="Año"
              return-object
              single-line
              hide-details
            ></v-select>

				  </v-card-text>
				</v-card>
			</v-col>
			<v-col cols="4" xs="12" sm="6" md="4"  class="pa-0" >
				<v-card class="elevation-4 transparent ma-1" outlined >
				  <v-img src="@/assets/logo.png" contain height="200" v-if="serie.imagename == ''"></v-img>
				  <v-img :src="img" contain height="200" v-else></v-img>
				  </v-card-title>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" class="pa-0" >
				<v-card>
			    <v-card-title>
			      <v-text-field
			        v-model="search"
			        append-icon="search"
			        label="Buscar"
			        single-line
			        hide-details
			      ></v-text-field>
			    </v-card-title>
			    <v-data-table
			      :headers="headers"
			      :items="subseries"
			      :search="search"
			      fixed-header
	          height="400"
	          hide-default-footer
	          loading-text="Cargando..."
	          dense
	          :items-per-page="longitud"
	          :mobile-breakpoint="250"
			    >
			    	<template v-slot:item.actions="{ item }">
				      <v-btn color="primary" @click="verDetalle(item)" small fab icon><v-icon>visibility</v-icon></v-btn>
				    </template>
			    </v-data-table>
			  </v-card>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
export default {
    data:()=>({
    	secundario: [],
    	search:'',
      series:[],
      subseries:[],
      show: false,
      categorias:[],
      seriecatego:{idcategoria: '', idserie:'', nomcatego:''},
      serie:{idserie: '', nomserie:'', imagename:''},
      headers: [
        { text: 'Serie',align: 'start',  value: 'nomserie'},
        { text: 'Subserie',align: 'start',  value: 'nomsubserie'},
        { text: 'Año', value: 'nomcatego' },
        { text: 'Ver', value:'actions'}
      ],
      longitud:5,

      img:'',
    }),

    created(){
    	this.getSeries()
			this.getSubseries()
    },

    watch:{
    	seriecatego(){
    		this.subseries = []
    		this.categorias = []
    		for (const i in this.secundario) {
    			if(this.secundario[i].nomserie == this.serie.nomserie && this.secundario[i].nomcatego == this.seriecatego.nomcatego){
    				this.subseries.push(this.secundario[i])
    			}
    		}
    	},

    	serie(){
    		if(this.serie.idserie == 0){
    			this.img = ''
	    		this.subseries = []
	    		this.categorias = []
	    		for (const i in this.secundario) {
	    			this.subseries.push(this.secundario[i])
	    		}
    		}else{
	    		this.img = this.serie.imagename
	    		this.subseries = []
	    		this.categorias = []
	    		for (const i in this.secundario) {
	    			if(this.secundario[i].nomserie == this.serie.nomserie){
	    				this.subseries.push(this.secundario[i])
	    			}
	    		}
	    	}
      },

    },	

    methods:{
	    getSeries(){
	    	this.serie = {idserie: '', nomserie:'', imagename:''}
	    	this.seriecatego = {idcategoria: '', idserie:'', nomcatego:''}
	    	this.search = ''
	    	this.series = []
	    	this.series = []
	      this.$http.get('clasificacion.series').then(response=>{
	      	var series = response.body
	      	this.$http.get('clasificacion.subseries').then(response=>{
		        this.subseries = response.body
		      	for (var i = 0; i <= series.length - 1; i++) {
		          if(series[i].imagename != ''){
		            series[i].imagename = this.$http.options.root + 'fotos/' +  series[i].imagename
		          }
          		this.series.push({
		          	nomserie: series[i].nomserie,
		          	idserie: series[i].idserie,
		          	show: false,
		          	imagename: series[i].imagename,
		          	subseries:[],
		          	categorias:[]
		          })
		          for (var j = 0; j <= this.subseries.length - 1; j++) {
		          	if(this.subseries[j].idserie == series[i].idserie){
		          		this.series[i].subseries.push(this.subseries[j])
		          	}
		          }
		      	}

		      	this.series.unshift({
		      		nomserie: 'TODAS LAS SERIES',
	          	idserie: 0,
	          	show: false,
	          	imagename: 0,
	          	subseries:[],
	          	categorias:[]
		      	})
		      	this.getCatego()
		        this.secundario = this.subseries
		        this.longitud = this.secundario.length
		      }).catch(error=>{console.log(error)})
	      }).catch(error=>{console.log(error)})
	    },

	    getCatego(){
	    	this.$http.get('clasificacion.categoria.serie').then(response=>{
      		this.categorias = response.body
      		for (var i = 0; i <= this.series.length - 1; i++) {
      			for (var j = 0; j <= this.categorias.length - 1; j++) {
	          	if(this.series[i].idserie == this.categorias[j].idserie){
	          		this.series[i].categorias.push(this.categorias[j])
	          	}
	          }
      		}
      	}).catch(error=>{console.log(error)})
	    },

	    getSubseries(){
	    	this.subseries = []
	      this.$http.get('clasificacion.subseries').then(response=>{
	        this.subseries = response.body
	      }).catch(error=>{console.log(error)})
	    },

	    verDetalle(subserie){
	    	this.$router.push({name:'versubserie', params:{docum: subserie.docum1 ,detalle: subserie}})
	    },

	    abrir(value){
	    	if(value.categorias.length > 0){
	    		this.seriecatego = {
	    			idcategoria: value.categorias[0].idcategoria, 
	    			idserie:value.idserie, 
	    			nomcatego:value.categorias[0].nomcatego
	    		}
	    	}

	    	value.show =! value.show
	    	for (var i = 0; i <= this.series.length - 1; i++) {
	    		if(this.series[i].idserie == value.idserie){
	    		}else{
	    			if(value.show == false){
	    				this.series[i].show = false
	    			} else{
	    				this.series[i].show =! value.show
	    			}
	    		}
	    	}
	    	this.getCatego()
	    }
	  },

	  computed:{
	  	filterSeries: function(){
    		var me = this
	    	if(this.series){
		      return this.series.filter((serie)=>{
		        var nom = serie.nomserie.toLowerCase();
		        return nom.match(this.search.toLowerCase());
		      })
	    	}
	    },
	  }

}
</script>